import api from '@/api';

import { PageResult } from '@/core/request/PageResult';

import {
  ListAreasQuery,
  Area,
  CreateAreaRequest,
  UpdateAreaRequest,
} from './Areas.types';

import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/areas`;

export async function listAreas(
  params: ListAreasQuery,
): Promise<PageResult<Area>> {
  const result = (await api.get(`${CONTROLLER_URL}`, params)) as unknown;

  return result as PageResult<Area>;
}

export async function getArea(id?: number): Promise<Area> {
  const result = (await api.get(`${CONTROLLER_URL}/${id}`, null)) as unknown;

  return result as Area;
}

export async function createArea(obj: CreateAreaRequest): Promise<Area> {
  const result = (await api.post(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as Area;
}

export async function updateArea(obj: UpdateAreaRequest): Promise<Area> {
  const result = (await api.put(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as Area;
}

export async function deleteArea(id: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${id}`,
    {},
    null,
  )) as unknown;

  return result;
}

export async function activateOrInactivateArea(areaId: number) {
  const result = (await api.put(
    `${CONTROLLER_URL}/${areaId}/activate`,
    {},
    null,
  )) as unknown;
  return result;
}
